import primitives from '@veneer/primitives';

export const VIEW_TYPES = {
  PICKUP_JOBS: 'private-pickup-jobs',
  RECENT_PRINT_HISTORY: 'recent-print-history',
};

export const TAB_CONFIG = [
  {
    id: VIEW_TYPES.PICKUP_JOBS,
    labelKey: 'dashboard.privatePickupFiles.privatePickupJobs.button',
    testId: 'private-pickup-jobs-tab-button',
  },
  {
    id: VIEW_TYPES.RECENT_PRINT_HISTORY,
    labelKey: 'dashboard.privatePickupFiles.recentPrintHistory.button',
    testId: 'print-history-tab-button',
  },
];

export const COLOR_MODES = {
  COLOR: 'color',
  BLACK_AND_WHITE: 'black',
  GRAY: 'gray',
  AUTO: 'auto',
};

export const STATUS = {
  COMPLETED: {
    color: primitives.color.green6,
    labelKey: 'dashboard.privatePickupFiles.status.success',
    type: 'completed',
  },
  CANCELED: {
    color: '#858585', // TODO: replace with primitive when available in veneer (update on SMBP-3988)
    labelKey: 'dashboard.privatePickupFiles.status.cancelled',
    type: 'canceled',
  },
  ABORTED: {
    color: primitives.color.red6,
    labelKey: 'dashboard.privatePickupFiles.status.failed',
    type: 'aborted',
  },
  READY: {
    color: '#296EF9', // TODO: replace with primitive when available in veneer (update on SMBP-3988)
    labelKey: 'dashboard.privatePickupFiles.status.ready',
    type: 'ready',
  },
  PREPARING: {
    color: '#568393', // TODO: replace with primitive when available in veneer (update on SMBP-3988)
    labelKey: 'dashboard.privatePickupFiles.status.preparing',
    type: 'preparing',
  },
};

export const COLUMNS = [
  {
    id: 'fileName',
    labelKey: 'dashboard.privatePickupFiles.columns.fileName',
    width: 260,
  },
  {
    id: 'status',
    labelKey: 'dashboard.privatePickupFiles.columns.status',
    width: 146,
  },
  {
    id: 'printer',
    labelKey: 'dashboard.privatePickupFiles.columns.printer',
    width: 146,
  },
  {
    id: 'pages',
    labelKey: 'dashboard.privatePickupFiles.columns.pages',
    width: 92,
  },
  {
    id: 'color',
    labelKey: 'dashboard.privatePickupFiles.columns.color',
    width: 76,
  },
  {
    id: 'submitTime',
    labelKey: 'dashboard.privatePickupFiles.columns.submitTime',
    width: 224,
  },
];
